"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.goTrue = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var goTrue = function goTrue(client) {
  return {
    type: 'goTrue',
    client: client,
    login: function () {
      var _login = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
        var email, password, remember;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = _ref.email, password = _ref.password, remember = _ref.remember;
                return _context.abrupt("return", client.login(email, password, remember));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function login(_x) {
        return _login.apply(this, arguments);
      }

      return login;
    }(),
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var user;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return client.currentUser();

              case 2:
                user = _context2.sent;
                return _context2.abrupt("return", user === null || user === void 0 ? void 0 : user.logout());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }(),
    getToken: function () {
      var _getToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var user;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return client.currentUser();

              case 2:
                user = _context3.sent;
                return _context3.abrupt("return", (user === null || user === void 0 ? void 0 : user.jwt()) || null);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }(),
    getUserMetadata: function () {
      var _getUserMetadata = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", client.currentUser());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getUserMetadata() {
        return _getUserMetadata.apply(this, arguments);
      }

      return getUserMetadata;
    }()
  };
};

exports.goTrue = goTrue;